import { VendorCategoryListPage } from '@/features/vendor-category/pages/VendorCategoryListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/vendor-category/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["vendor_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VendorCategoryListPage,
})
